import React, { useState, useContext, useEffect } from 'react';
import { usersPathTo } from '../utils/Api';
import { UserContext } from '../contexts/UserContext';
import SnackbarContext from '../contexts/SnackbarContext';
import TextField from '@mui/material/TextField';
import { Box, Typography, Link, Button, Card, CardActionArea, CardContent } from '@mui/material';
import TudoPetsLogo from '../images/tp_logo_laranja.png';
import { useNavigate } from 'react-router-dom';
/* Icons */
import EmailIcon from '@mui/icons-material/Email';
import KeyIcon from '@mui/icons-material/Key';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import { layoutCardRadius } from '../theme/colors';

/* Padrão Campos Login */
const FieldLogin = ({ label, icon, type = 'text', value, onChange, placeholder, onKeyPress, name, showPasswordToggle = false, onTogglePassword, showPassword }) => {

  const getIcon = () => {
    if (icon) return icon;
    // Fallback para ícones padrão baseado no tipo
    if (type === 'email') return <EmailIcon sx={{ fontSize: 16 }} />;
    if (type === 'password') return <KeyIcon sx={{ fontSize: 16 }} />;
    return null;
  };

  return (
    /* Login/Email */
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, alignSelf: 'stretch' }}>
      {/* Título Campo */}
      <Typography sx={{ color: 'text.primary', fontFamily: 'Nunito', fontSize: '14px', fontWeight: 700, lineHeight: '14px' }}>
        {label}
      </Typography>

      {/* TextField */}
      <Box sx={{ position: 'relative', width: '100%' }}>
        <TextField
          placeholder={placeholder}
          name={name}
          variant="outlined"
          type={showPasswordToggle && showPassword ? 'text' : type}
          value={value}
          onChange={onChange}
          onKeyPress={onKeyPress}
          fullWidth
          InputProps={{
            sx: {
              bgcolor: 'surface.input',
              borderRadius: layoutCardRadius,
              /* Estilo do input */
              '& .MuiOutlinedInput-input': {
                paddingLeft: '45px !important',
                paddingRight: showPasswordToggle ? '45px !important' : '14px',
                zIndex: 5,

                /* Borda do autofill */
                '&:-webkit-autofill': {
                  borderRadius: `${layoutCardRadius} !important`,
                  zIndex: 1,
                },
              },

              /* Campo preenchido */
              '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: '1px',
                borderRadius: `${layoutCardRadius} !important`,
                zIndex: 2,
              },
            }
          }}
        />

        {/* Icone */}
        <Box sx={{ /* zIndex = 10 alta prioridade */
          position: 'absolute',
          left: '16px',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 10,
          display: 'flex',
          alignItems: 'center',
        }}>
          {getIcon()}
        </Box>

        {/* Botão de ver senha*/}
        {showPasswordToggle && (
          <IconButton
            tabIndex={-1}
            onClick={onTogglePassword}
            sx={{
              position: 'absolute',
              right: '16px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
              color: 'text.secondary',
              padding: '4px',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              }
            }}
          >
            {showPassword ? <VisibilityOffIcon sx={{ fontSize: 16 }} /> : <VisibilityIcon sx={{ fontSize: 16 }} />}
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const { openSnackbar } = useContext(SnackbarContext);
  const navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  /*Mostrar/ocultar senha*/
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (currentUser) {
      navigate('/home');
    }
  }, [currentUser, navigate]);

  useEffect(() => {
    document.title = 'Entrar - TudoPets.app';
  }, []);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    usersPathTo.login({ email: email, password: password }).then(result => {
      setCurrentUser(result.data);
      localStorage.setItem('current_user', JSON.stringify(result.data))
    }, error => {
      openSnackbar(error.response.data.error, "error");
      console.log("login error", error);
    })
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    if (!email) {
      openSnackbar("Por favor, informe seu email.", "error");
      return;
    }
    usersPathTo.forgot_password({ email: email }).then(result => {
      localStorage.setItem('forgot_password_email', email)
      openSnackbar("E-mail de redefinição de senha enviado, verifique sua caixa de entrada.", "success");
    }, error => { })
  }

  const containerFlex = {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'stretch'
  }

  const columnCentered = {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'stretch',
    gap: 2,
    alignItems: 'center'
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'center', width: '100%' }}>
      <Card sx={{ display: 'flex', padding: '24px', flexDirection: 'column', alignItems: 'center', gap: 4, maxWidth: '400px', width: '100%', mt: 4 }}>
        {/* Topo e Login */}
        <Box sx={{ ...containerFlex, alignItems: 'flex-start', gap: 6 }}>

          {/* Logo */} {/* Como fica? */}
          <Box sx={{ ...columnCentered }}>
            <Box component="img" src={TudoPetsLogo} alt="Logo TudoPets"
              sx={{ width: '100%', height: 'auto', p: 2 }} />
          </Box>

          {/*onSubmit={handleSubmit} */}
          {/* Login */}
          <Box sx={{ ...columnCentered }}>
            {/* Email */}
            <FieldLogin
              label="Email"
              type="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="Digite seu email"
              name="email"
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSubmit(e);
                }
              }} />

            {/* Senha */}
            <FieldLogin
              label="Senha"
              type="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder=""
              name="password"
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSubmit(e);
                }
              }}
              showPasswordToggle={true}
              showPassword={showPassword}
              onTogglePassword={handleTogglePassword}
            />
            {/* Checkbox e Recuperar Senha */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, alignSelf: 'stretch', justifyContent: 'space-between' }} >
              {/* Checkbox */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                }
                label={<Typography>Lembrar de mim</Typography>}
              />

              {/* Recuperar Senha */}
              <Typography>
                <Link onClick={handleForgotPassword}
                  sx={{ cursor: 'pointer', textDecorationLine: 'underline' }}>
                  Esqueci a senha
                </Link>
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Login e Criar conta */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, alignSelf: 'stretch' }}>

          {/* Login */}
          <Button
            variant="pillContained"
            color="secondary"
            onClick={handleSubmit}
            fullWidth
          >
            Entrar
          </Button>

          {/* Criar conta */}
          <Typography>
            Ainda não tem uma conta? {' '}
            <Link onClick={() => navigate('/register')}
              sx={{ cursor: 'pointer', textDecorationLine: 'underline', fontWeight: 700 }}>
              Cadastre-se!
            </Link>
          </Typography>
        </Box>
      </Card>
    </Box>
  );
};

export default Login;
